import React from 'react'
import { Box } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { renderLayoutsSwitch } from '../../utils/contentRenderer'

const WebContentPage = (content) => {
    const mainRegionsContent = content?.content?.MainRegion
    const WebContentPageMarginPerDevice = content?.content?.WebContentPageMarginPerDevice

    return (
        <Box margin={{
                base: WebContentPageMarginPerDevice?.MarginMobile,
                md: WebContentPageMarginPerDevice?.MarginTablet,
                lg: WebContentPageMarginPerDevice?.MarginDesktop
            }}
            data-block-type="WebContentPage">
            {mainRegionsContent?.map((mainRegionContent, contentIndex) => {
                return (
                    <React.Fragment key={contentIndex}>
                        {renderLayoutsSwitch(mainRegionContent?.ContentLink?.Expanded)}
                    </React.Fragment>
                )
            })}
        </Box>
    )
}

WebContentPage.displayName = 'WebContentPage'

WebContentPage.propTypes = {
    content: PropTypes.object
}

export default WebContentPage
